export default "__VITE_ASSET__BGdbACmY__"